enum Attendance {
  NotPossible = 0,
  Possible = 1,
  Going = 2,
  Organizer = 3,
  Cancel = 4,
}

export default Attendance;
